import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=77736b10&"
import script from "./Orders.vue?vue&type=script&lang=js&"
export * from "./Orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\manla\\Downloads\\b\\public_html\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77736b10')) {
      api.createRecord('77736b10', component.options)
    } else {
      api.reload('77736b10', component.options)
    }
    module.hot.accept("./Orders.vue?vue&type=template&id=77736b10&", function () {
      api.rerender('77736b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/Orders.vue"
export default component.exports